@if (accounts$ | async; as accounts) {
<section>
  <div class="section-header d-flex align-items-center justify-content-between">
    <span
      data-e2e="active-account-quantity"
      class="text-muted"
      i18n="Account@@userMenuCurrentActiveAccounts"
      >{accounts.length, plural, =1 {{{accounts.length }} Active account} other
      {{{accounts.length }} Active accounts}}
    </span>
    <button
      i18n="Account|Change account button@@accountShowAllAction"
      (click)="navigate.emit()"
      type="button"
      data-e2e="change-account-btn"
      class="btn btn-primary btn-sm"
    >
      Change Account
    </button>
  </div>
  <div class="content position-relative">
    @for (account of accounts | slice: 0:maxShowedAccounts; track account) {
    <epc-account-information [account]="account"> </epc-account-information>
    }
    <div
      (click)="navigate.emit()"
      [class.stretched-link]="isAccountsClickable$ | async"
      class="btn-link text-decoration-none cursor-pointer"
    >
      @if (accounts.length - maxShowedAccounts > 0) {
      <span i18n="Account|And N more text@@accountNMore">
        and {{ accounts.length - maxShowedAccounts }} more...
      </span>
      }
    </div>
  </div>
</section>
}
